import { Skeleton, Button as AntdButton, Alert, Empty, Form } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from "react-router";
import { setCurrentBooking } from 'redux/actions/booking.actions';
import { getBookingDetails } from 'services/booking.service';
import "./Inventory.scss";
import { Button } from 'components/Buttons/Buttons';
import InventoryKitSearch from './components/KitSearch';
import { disposeInventory, getPreferenceCards, getSubmittedInventory } from 'services/inventory.service';
import ProductInventory from './components/ProductInventory';
import { filterInventoryKits, getSubmittableData, transformData } from './inventory.utils';
import { cloneDeep } from 'lodash';
import EventDrawer from 'components/EventDrawer/EventDrawer';

import SubmittedKits from './components/SubmittedKits';


export default function Inventory() {

  const [isSubmitted, setIsSubmitted] = useState(false);


  const [bookingDetails, setBookingDetails] = useState({
    data: null,
    isLoading: true
  })
  const [kitsData, setKitsData] = useState({
    data: null,
    kitNo: null,
    isLoading: false,
    isFetched: false
  })
  const [submittedKitsData, setSubmittedKitsData] = useState({
    data: null,
    isLoading: false,
    isFetched: false
  })

  const [showEventDrawer, setShowEventDrawer] = useState({
    visible: false,
    openPaymentDrawerDirectly: false,
  });

  const location = useLocation();
  const params = useParams();

  const dispatch = useDispatch()



  let formsRef = useRef({});

  const loadOrderData = async () => {
    const result = await dispatch(getBookingDetails(params.orderId))
    if (result?.status === 'success') {
      const resultBooking = result.data
      dispatch(setCurrentBooking(resultBooking))
      setBookingDetails({
        data: resultBooking,
        isLoading: false
      })

    }
  }

  const loadKitsData = async (kitNo) => {

    // if the same kit, do not reload
    if (kitsData.kitNo === kitNo) {
      return;
    }

    setKitsData({
      data: null,
      isLoading: true,
      isFetched: false,
      kitNo
    })

    const productId = bookingDetails?.data?.lineItems?.[0]?.productId
    const addonIds = bookingDetails?.data?.lineItems?.[0]?.addOns?.map(addOn => addOn.productId) ?? []

    const productName = bookingDetails?.data?.lineItems?.[0]?.productName
    const addonNames = bookingDetails?.data?.lineItems?.[0]?.addOns?.map(addOn => addOn.productName) ?? []


    const allIds = [productId, ...addonIds]
    const allNames = [productName, ...addonNames]
    const result = await dispatch(getPreferenceCards(allIds, kitNo))

    setKitsData({
      data: result?.data ? transformData(result.data, allNames) : null,
      isFetched: true,
      isLoading: false,
      kitNo
    })
  }


  useEffect(() => {
    loadOrderData()
  }, [params.orderId])

  useEffect(() => {
    async function loadSubmittedInventory() {
      setSubmittedKitsData({
        data: null,
        isLoading: true,
        isFetched: false,
      })

      const result = await dispatch(getSubmittedInventory(params.orderId))

      setSubmittedKitsData({
        data: result.data ? result.data : null,
        isFetched: true,
        isLoading: false,
      })
    }

    if (bookingDetails?.data?.isInventorySubmitted) {
      loadSubmittedInventory()
      console.log('bookingDetails', bookingDetails)
      loadKitsData(bookingDetails?.data?.inventoryKitNo)

    }
  }, [bookingDetails?.data?.isInventorySubmitted])


  const formRefs = useRef({});

  const registerForm = (key, form) => {
    formRefs.current[key] = form;
  };

  if (bookingDetails.isLoading) {
    return <div style={{ padding: 20 }}><Skeleton /></div>
  }

  if (!bookingDetails.data?.orderId) {
    return <Empty description="Failed to load data. Refresh to try again." />
  }


  const isOrderCompleted = bookingDetails?.data?.orderStatus === 3;
  const isInventorySubmitted = bookingDetails?.data?.isInventorySubmitted || isSubmitted;
  const addOns = bookingDetails?.data?.lineItems?.[0]?.addOns;


  async function handleSubmitInventory() {
    try {
      const formResults = await Promise.all(
        Object.values(formRefs.current).map(form =>
          form.validateFields().catch(({ errorFields }) => {
            form.scrollToField(errorFields[0].name, {
              scrollMode: "if-needed",
              block: "center",
              behavior: "smooth",
            });
            // throw error to trigger the outer catch
            return Promise.reject();
          })
        )
      );

      const submittableData = getSubmittableData(formResults)

      const result = await dispatch(
        disposeInventory(
          params.orderId,
          kitsData.kitNo,
          submittableData
        )
      )

      if (result?.status === 'success') {
        // update local booking
        setBookingDetails((state) => ({
          ...state,
          data: {
            ...state.data,
            isInventorySubmitted: true,
            inventoryKitNo: String(kitsData.kitNo),
          }
        }))
        setIsSubmitted(true);
        // update booking in redux?
        dispatch(
          setCurrentBooking({
            ...bookingDetails.data,
            isInventorySubmitted: true,
            inventoryKitNo: String(kitsData.kitNo),
          })
        );
        setShowEventDrawer({
          visible: true,
          openPaymentDrawerDirectly: true,
        });
        // load the submitted inventory data
      }



    } catch (err) {
      console.log("Validation failed:", err);
    }
  }

  function addSkuLot(kitIndex, lotIndex) {
    const kitsDataNew = cloneDeep(kitsData?.data || []);
    const productKitsNew = cloneDeep(kitsDataNew?.[kitIndex]);
    const lotNew = cloneDeep(productKitsNew?.kits?.[lotIndex]);
    lotNew.key = (productKitsNew?.kits?.length ?? 0)
    lotNew.isDynamic = true
    productKitsNew?.kits.splice(lotIndex + 1, 0, lotNew);
    kitsDataNew[kitIndex] = productKitsNew;

    setKitsData((state) => ({
      ...state,
      data: kitsDataNew
    }))
  }

  function removeSkuLot(kitIndex, lotIndex) {
    const kitsDataNew = cloneDeep(kitsData?.data || []);
    const productKitsNew = cloneDeep(kitsDataNew?.[kitIndex]);
    productKitsNew.kits = productKitsNew?.kits?.filter((it, index) => index !== lotIndex)
    kitsDataNew[kitIndex] = productKitsNew;

    setKitsData((state) => ({
      ...state,
      data: kitsDataNew
    }))
  }



  return (
    <>
      <div className='inventory'>
        {/* Head start */}
        <div className="head">
          <h2
            style={{
              color: "#15213B",
              fontFamily: "tradeGothicBold",
              margin: 0,
            }}
          >
            Inventory Management
          </h2>
          <AntdButton
            type="text"
            onClick={() => {
              dispatch(setCurrentBooking(bookingDetails.data));
              setShowEventDrawer({
                visible: true,
                openPaymentDrawerDirectly: false,
              });
            }}
          >
            Order Details
          </AntdButton>
        </div>
        {/* Head end */}
        {/* Body start */}
        <div className="body">
          {isOrderCompleted && (
            <Alert
              style={{
                marginBottom: 20,
              }}
              type="success"
              message="This order is completed."
            />
          )}
          <div>
            <div
              style={{
                borderBottom: "2px solid #f0f0f0",
                marginBottom: 16,
              }}
            >
              <InventoryKitSearch
                booking={bookingDetails.data}
                isFetched={kitsData?.flag}
                onSubmit={loadKitsData}
              />
            </div>
          </div>
          <Form.Provider
            onFormFinish={(name) => {
              console.log("form submit", name);
            }}
            onFormChange={(name, info) => {
              console.log('name, info', name, info)
            }}
          >

            {
              isInventorySubmitted && <SubmittedKits
                product={bookingDetails?.data?.formattedServicesWithBoostsString}
                submittedKits={submittedKitsData}
                isFetched={kitsData?.isFetched}
                isLoading={kitsData?.isLoading}
                preferenceCards={kitsData?.data}
              />
            }
            {
              !isInventorySubmitted && <ProductInventory
                key={0}
                kits={kitsData?.data?.[0]?.kits}
                isLoading={kitsData.isLoading}
                isFetched={kitsData.isFetched}
                product={bookingDetails?.data?.lineItems?.[0]}
                hasPreferenceCard={bookingDetails?.data?.lineItems?.[0]?.hasPreferenceCard}
                wasFound={kitsData?.data?.[0]?.wasFound}
                registerForm={(form) => registerForm(0, form)}
                addSkuLot={(lotIndex) => addSkuLot(0, lotIndex)}
                removeSkuLot={(lotIndex) => removeSkuLot(0, lotIndex)}
              // isSubmitted={isInventorySubmitted}
              // submittedKits={submittedKitsData?.data?.filter(kit => kit.comment === String(bookingDetails?.data?.lineItems?.[0]?.productId))}
              />
            }

            {
              !isInventorySubmitted && addOns?.map((addon, index) => (
                <ProductInventory
                  key={index + 1}
                  kits={kitsData?.data?.[index + 1]?.kits}
                  isLoading={kitsData.isLoading}
                  isFetched={kitsData.isFetched}
                  product={addon}
                  hasPreferenceCard={addon?.hasPreferenceCard}
                  wasFound={kitsData?.data?.[index + 1]?.wasFound}
                  registerForm={(form) => registerForm(index + 1, form)}
                  addSkuLot={(lotIndex) => addSkuLot(index + 1, lotIndex)}
                  removeSkuLot={(lotIndex) => removeSkuLot(index + 1, lotIndex)}
                // isSubmitted={isInventorySubmitted}
                // submittedKits={submittedKitsData?.data?.filter(kit => kit.comment === String(addon?.productId))}
                />
              ))
            }
            <br />
            <div
              style={{
                display: "flex",
                gap: 16,
              }}
            >
              <Button
                rounded={true}
                disabled={isInventorySubmitted}
                onClick={handleSubmitInventory}
              >
                {isInventorySubmitted ? "Submitted" : "Submit"}
              </Button>
              <Button
                disabled={isOrderCompleted || !isInventorySubmitted}
                onClick={async () => {
                  dispatch(
                    setCurrentBooking({
                      ...bookingDetails.data,
                    })
                  );
                  setShowEventDrawer({
                    visible: true,
                    openPaymentDrawerDirectly: true,
                  });
                }}
                // disable={isFetched}
                rounded={true}

              // disabled={isComplete}
              >
                Pay
              </Button>
            </div>
          </Form.Provider>

        </div>
        {/* Body end */}
      </div>
      <EventDrawer
        inventoryLinks={false}
        visible={showEventDrawer?.visible}
        openPaymentDrawerDirectly={showEventDrawer?.openPaymentDrawerDirectly}
        setShowEventDrawer={(visible) =>
          setShowEventDrawer({
            visible,
            openPaymentDrawerDirectly: false,
          })
        }
        getData={loadOrderData}
        onClose={() => setShowEventDrawer(false)}
      />
    </>
  )
}
